import React from "react";
import Box from "@mui/material/Box";
import { Controller } from "react-hook-form";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import { styled } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import "../styles.css";

const FormMultiSelect = ({
  name,
  control,
  label,
  options,
  onChange,
  defaultValue,
  width,
  formLabel,
  error,
  disabled = false,
  margin = "0",
}) => {
  const isMediumScreen = useMediaQuery("(max-width:900px)");

  const StyledAutocomplete = styled(Autocomplete)(() => ({
    width: width || "100%",
    margin: margin,
    borderRadius: "6px",
    marginTop: isMediumScreen ? "13px" : "0",
    backgroundColor: disabled ? "#f5f5f5" : "#fff",
    "& .MuiOutlinedInput-root": {
      minHeight: "40px",
      padding: "2px 8px",
      borderRadius: "6px",
      alignItems: "center",
      flexWrap: "nowrap",
      overflow: "hidden",
      backgroundColor: disabled ? "#f5f5f5" : "#fff"
    },
    "& .MuiAutocomplete-inputRoot": {
      paddingTop: "2px !important",
      paddingBottom: "2px !important"
    },
    "& .MuiAutocomplete-input": {
      minWidth: "60px !important",
      padding: "6.5px 4px !important"
    },
    "& .MuiAutocomplete-tag": {
      margin: "2px 4px 2px 0",
      maxWidth: "calc(100% - 60px)"
    },
    "& .MuiAutocomplete-endAdornment": {
      top: "calc(50% - 14px)"
    }
  }));

  return (
    <Box sx={{ minWidth: 120, width: width || "100%" }}>
      {(label || formLabel) && (
        <p className="select-form-label" style={{ marginBottom: 6 }}>{label || formLabel}</p>
      )}
      <FormControl fullWidth error={Boolean(error)}>
        <Controller
          name={name}
          disabled={disabled}
          control={control}
          defaultValue={defaultValue ?? []}
          render={({ field }) => {
            const selectedValues = Array.isArray(field.value) ? field.value : [];
            const selectedOptions = options.filter((opt) =>
              selectedValues.includes(opt.value)
            );

            return (
              <StyledAutocomplete
                multiple
                limitTags={1}
                disableCloseOnSelect
                options={options}
                getOptionLabel={(option) => (option && option.name) || ""}
                isOptionEqualToValue={(option, value) =>
                  option && value && option.value === value.value
                }
                value={selectedOptions}
                onChange={(event, newValue) => {
                  const values = Array.isArray(newValue)
                    ? newValue.map((opt) => opt.value)
                    : [];
                  field.onChange(values);
                  onChange?.(values);
                }}
                disabled={disabled}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Buscar o seleccionar..."
                    error={!!error}
                    helperText={error?.message}
                    inputProps={{
                      ...params.inputProps
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        minHeight: "40px",
                        "& fieldset": { borderRadius: "6px" }
                      }
                    }}
                  />
                )}
                renderTags={(tagValue, getTagProps) =>
                  tagValue.map((option, index) => (
                    <Chip
                      key={option.value}
                      label={option.name}
                      size="small"
                      {...getTagProps({ index })}
                      sx={{
                        maxWidth: 180,
                        height: 20,
                        margin: "2px 4px 2px 0",
                        "& .MuiChip-label": {
                          fontSize: 11,
                          paddingLeft: "8px",
                          paddingRight: "8px"
                        }
                      }}
                    />
                  ))
                }
                fullWidth
              />
            );
          }}
        />
        {error && (
          <p className="error-message" style={{ marginTop: "4px", color: "red", fontSize: 12 }}>
            {error.message}
          </p>
        )}
      </FormControl>
    </Box>
  );
};

export default FormMultiSelect;
